import type { IconSvgObject } from './types';

const ArrowDownRight02Icon: IconSvgObject = [
  ["path", { d: "M14 14L6 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 17L17 11L18 18L11 17Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDownRight02Icon;
